(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fdo-gift-finder"] && !Shopify.designMode) return;
  try {
    
(function() {
  var answers = {};
  var currentStep = 0;

  var recommendations = {
    experience: { icon: '&#127981;', title: 'The Atelier Experience', desc: 'Craft your own ring or necklace in gold or silver at our Munich studio. Hands-on, unforgettable, and entirely yours.', cta: 'Book a Session', url: '/pages/create-your-own' },
    flowers:    { icon: '&#127826;', title: 'Jewelry & Everlasting Flowers', desc: 'A matching set of personalized jewelry paired with roses that last up to 3 years. The gift that truly stays.', cta: 'Shop Bundles', url: '/collections/timeless-blooms' },
    personal:   { icon: '&#9999;&#65039;', title: 'Personalized Engraving', desc: 'Names, dates, fingerprints or coordinates. No two pieces are ever alike.', cta: 'Shop Engraving', url: '/collections/tailored-jewelry' },
    minimal:    { icon: '&#129001;', title: 'Fine Minimalist Jewelry', desc: 'Elegant, timeless pieces in sterling silver and gold. Quiet luxury that speaks volumes.', cta: 'Shop Collection', url: '/collections/all-products' },
    couple:     { icon: '&#128145;', title: 'Couples Collection', desc: 'Matching rings, twin necklaces and shared engravings. Love made wearable.', cta: 'Shop for Couples', url: '/collections/love-engagement' },
    him:        { icon: '&#9939;&#65039;', title: 'Jewelry for Him', desc: 'Bold and minimal pieces designed specifically for men. Bracelets, rings and pendants with edge.', cta: 'Shop for Him', url: '/collections/mens-jewellery' },
    birthday:   { icon: '&#127874;', title: 'Birthday Gifts', desc: 'A piece they\u2019ll wear and remember every single day. Personalized with their name, initials or a special date.', cta: 'Shop Birthday Gifts', url: '/collections/all-products' },
    anniversary:{ icon: '&#128142;', title: 'Anniversary Jewelry', desc: 'Mark the milestone with something that lasts forever. Engrave the date, the coordinates, or the words that matter most.', cta: 'Shop Anniversary', url: '/collections/love-engagement' },
    default:    { icon: '&#10024;', title: 'Our Bestsellers', desc: 'Hand-picked pieces loved by thousands. Personalized, meaningful and beautiful.', cta: 'Shop Bestsellers', url: '/collections/all-products' }
  };

  function getRecommendation() {
    if (answers[3] === 'experience') return recommendations.experience;
    if (answers[3] === 'flowers')    return recommendations.flowers;
    if (answers[3] === 'personal')   return recommendations.personal;
    if (answers[1] === 'couple')     return recommendations.couple;
    if (answers[1] === 'him')        return recommendations.him;
    if (answers[2] === 'anniversary') return recommendations.anniversary;
    if (answers[2] === 'birthday')   return recommendations.birthday;
    if (answers[3] === 'minimal')    return recommendations.minimal;
    return recommendations.default;
  }

  function updateProgress(step) {
    var fill = document.getElementById('fdo-quiz-progress-fill');
    var label = document.getElementById('fdo-quiz-step-label');
    if (fill) fill.style.width = ((step / 3) * 100) + '%';
    if (label) label.textContent = 'Step ' + step + ' of 3';
  }

  function showResult() {
    document.getElementById('fdo-quiz-steps').style.display = 'none';
    var result = document.getElementById('fdo-quiz-result');
    result.style.display = 'flex';
    var rec = getRecommendation();
    document.getElementById('fdo-result-icon').innerHTML = rec.icon;
    document.getElementById('fdo-result-title').textContent = rec.title;
    document.getElementById('fdo-result-desc').textContent = rec.desc;
    var cta = document.getElementById('fdo-result-cta');
    cta.textContent = rec.cta;
    cta.href = rec.url;
    result.classList.add('fdo-quiz__result--visible');
  }

  document.addEventListener('DOMContentLoaded', function() {
    var startBtn = document.getElementById('fdo-quiz-start');
    if (startBtn) {
      startBtn.addEventListener('click', function() {
        document.getElementById('fdo-quiz-intro').style.display = 'none';
        document.getElementById('fdo-quiz-steps').style.display = 'block';
        updateProgress(1);
      });
    }

    document.querySelectorAll('.fdo-quiz__opt').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var step = parseInt(this.getAttribute('data-step'));
        var val  = this.getAttribute('data-val');
        answers[step] = val;

        this.closest('.fdo-quiz__options').querySelectorAll('.fdo-quiz__opt').forEach(function(b) {
          b.classList.remove('fdo-quiz__opt--selected');
        });
        this.classList.add('fdo-quiz__opt--selected');

        setTimeout(function() {
          if (step < 3) {
            document.getElementById('fdo-step-' + step).style.display = 'none';
            document.getElementById('fdo-step-' + (step + 1)).style.display = 'block';
            updateProgress(step + 1);
          } else {
            showResult();
          }
        }, 340);
      });
    });

    var restart = document.getElementById('fdo-quiz-restart');
    if (restart) {
      restart.addEventListener('click', function() {
        answers = {};
        document.getElementById('fdo-quiz-result').style.display = 'none';
        document.getElementById('fdo-quiz-result').classList.remove('fdo-quiz__result--visible');
        document.querySelectorAll('.fdo-quiz__opt').forEach(function(b) { b.classList.remove('fdo-quiz__opt--selected'); });
        for (var i = 1; i <= 3; i++) {
          var el = document.getElementById('fdo-step-' + i);
          if (el) el.style.display = i === 1 ? 'block' : 'none';
        }
        document.getElementById('fdo-quiz-steps').style.display = 'block';
        updateProgress(1);
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
  connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["occasions-home"] && !Shopify.designMode) return;
  try {
    
(function() {
  var track = document.getElementById('fdo-occ-track');
  var btnL  = document.getElementById('fdo-occ-left');
  var btnR  = document.getElementById('fdo-occ-right');
  var thumb = document.getElementById('fdo-occ-thumb');
  if (!track) return;

  function scrollBy(dir) { track.scrollBy({ left: dir * 240, behavior: 'smooth' }); }

  function updateUI() {
    var atStart = track.scrollLeft <= 4;
    var atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    btnL.style.opacity = atStart ? '0.35' : '1';
    btnL.style.pointerEvents = atStart ? 'none' : 'auto';
    btnR.style.opacity = atEnd ? '0.35' : '1';
    btnR.style.pointerEvents = atEnd ? 'none' : 'auto';
    var ratio = track.scrollLeft / (track.scrollWidth - track.clientWidth);
    var tw = (track.clientWidth / track.scrollWidth) * 100;
    thumb.style.width = tw + '%';
    thumb.style.left  = (ratio * (100 - tw)) + '%';
  }

  btnL.addEventListener('click', function() { scrollBy(-1); });
  btnR.addEventListener('click', function() { scrollBy(1); });
  track.addEventListener('scroll', updateUI);
  window.addEventListener('resize', updateUI);
  updateUI();

  /* Drag scroll on thumb */
  var prog  = document.getElementById('fdo-occ-progress');
  var dragging = false, dragStartX, dragStartLeft;
  thumb.addEventListener('mousedown', function(e) {
    dragging = true; dragStartX = e.pageX; dragStartLeft = thumb.offsetLeft;
    document.body.style.userSelect = 'none';
  });
  document.addEventListener('mousemove', function(e) {
    if (!dragging) return;
    var dx = e.pageX - dragStartX;
    var tw2 = thumb.offsetWidth;
    var newL = Math.max(0, Math.min(dragStartLeft + dx, prog.offsetWidth - tw2));
    thumb.style.left = (newL / prog.offsetWidth * 100) + '%';
    track.scrollLeft = (newL / (prog.offsetWidth - tw2)) * (track.scrollWidth - track.clientWidth);
  });
  document.addEventListener('mouseup', function() {
    dragging = false; document.body.style.userSelect = '';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seondsec-home"] && !Shopify.designMode) return;
  try {
    
(function() {
  function animateCounters() {
    document.querySelectorAll('.fdo-counters__number[data-target]').forEach(function(el) {
      var target = parseFloat(el.getAttribute('data-target'));
      var suffix = el.getAttribute('data-suffix') || '';
      var isDecimal = target % 1 !== 0;
      var duration = 1600;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var ease = 1 - Math.pow(1 - p, 3);
        var val = target * ease;
        el.textContent = (isDecimal ? val.toFixed(1) : Math.floor(val)) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = (isDecimal ? target.toFixed(1) : target) + suffix;
      }
      requestAnimationFrame(step);
    });
  }
  var section = document.getElementById('trust-stats');
  if (!section) return;
  var done = false;
  new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting && !done) { done = true; animateCounters(); }
  }, { threshold: 0.25 }).observe(section);
})();

  } catch(e) { console.error(e); }
})();
})();
